export * from './test.module';

export { TestComponent } from './test.component';



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/test/index.ts